import React, { ReactElement } from 'react';
import { CellProps } from 'react-table';
import styles from './index.module.css';

export function TruncatedCell<T extends Record<string, unknown>>({
  value,
}: CellProps<T>): ReactElement {
  return <span className={styles.root}>{value}</span>;
}
